import React from 'react';
import { Authenticator, View, Image, useTheme, Text, components } from '@aws-amplify/ui-react';



const Footer = () => (
    <footer className="footer">
        <p>All Rights Reserved - George Mason University - IT493 Tech Titans</p>
    </footer>
);

export default Footer;